import React, { Component } from 'react'
import { Nav, Navbar } from 'react-bootstrap'
import Fade from 'react-reveal/Fade'
import ReactGA from 'react-ga';

const styles={
    "buttonHeader" : {
        'color': '#fff'
    },
    "navbar": {
        'background-color': '#fff'
    },
    "logo":{
        'width': '70%',
        'height': '70%'
    }
}


export class Header extends Component {
    constructor(){
        super();
        const trackingId = "UA-145243581-4"; // PP DCH 2019
        ReactGA.initialize(trackingId);
        
        this.handleRegisterClicked = this.handleRegisterClicked.bind(this);
    }

    handleRegisterClicked(location){
        ReactGA.event({
            category: "Register",
            action: "Clicked",
            label: location
        });
    }

    render() {
        return (
            <header className="site-header">
                <Navbar  expand="lg">
                    <div className="container ">
                    
                        <Navbar.Brand href="#home">
                            <Fade left>
                                <img src={require("../../assets/logos/DCH-9.png")} style={styles.logo} alt="" />
                            </Fade>
                        </Navbar.Brand>
                        <Navbar.Toggle aria-controls="basic-navbar-nav" />
                        <Navbar.Collapse id="basic-navbar-nav">
                            <Nav className="ml-auto">
                                <Nav.Link href="#category">Category</Nav.Link>
                                <Nav.Link href="#about">About</Nav.Link>
                                <Nav.Link href="#timeline">Timeline</Nav.Link>
                                <Nav.Link href="#faq">FAQ</Nav.Link>
                                {/* <Nav.Link href="#sponsor">Sponsor</Nav.Link> */}
                            </Nav>
                            <div className="header-btns">
                                <a href="https://docs.google.com/forms/d/e/1FAIpQLSejzfZt512gFkpU5peH4lq_yl_Ff5e0KG7P12doBoITcl31QQ/viewform" 
                                style={styles.buttonHeader}
                                onClick={()=>this.handleRegisterClicked('header')}
                                target="_blank" without rel="noopener noreferrer">
                                    <div className="btn-2">
                                            Register
                                    </div>
                                </a>
                            </div>
                        </Navbar.Collapse>

                    </div>
                </Navbar>
            </header>

        )
    }
}

export default Header
